
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container, Typography, Button, Skeleton } from "@mui/material";
import CardNoticiaCaroussel from './cardNoticiaCaroussel';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'; 
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import 'swiper/css';
import 'swiper/css/pagination';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 70,
    marginBottom: 20,
  },
}))


export default function CarousselNoticias() {
  const classes = useStyles();
  const navigate = useNavigate()
  const [noticias, setNoticias] = useState('')

  useEffect(() => {
    api.get(`/noticias?perPage=10`)
      .then(response => {
        // console.log(response)
        setNoticias(response.data.noticias);
        localStorage.setItem('noticiaId', response.data.noticias[0]?._id || '');
      }).catch(error => {
        // console.log(error)
      })
  }, [])

  function SkeletonCard() {
    return (
      <Box>
        <Box sx={{ width: 210, marginRight: 0.5, my: 5 }} className="h-[350px]">
          <Skeleton animation="wave" variant="rectangular" width={210} className="h-[200px]" />
          <Box sx={{ pt: 0.5 }}>
            <Skeleton animation="wave" />
            <Skeleton animation="wave" width="60%" />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <div className={classes.root} >

      <Container>

        <Typography align="center" variant="h1" style={{ margin: '1rem', fontSize: 25, fontWeight: 'bold', }}>
          NOTÍCIAS
        </Typography>

        <Swiper
          breakpoints={{
            // Configurações quando a largura da tela for >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            // Configurações quando a largura da tela for >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            // Configurações quando a largura da tela for >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
            // ... Adicione mais breakpoints conforme necessário
          }
          pagination={{
            clickable: true,
          }}

          modules={[Pagination]}
          className="mySwiper"
        >
          {noticias ?
            noticias.map((noticia) => (

              <SwiperSlide key={noticia._id}>
                <CardNoticiaCaroussel noticia={noticia} />
              </SwiperSlide>
            ))
            :
            [...Array(10)].map((_, index) => (
              <SwiperSlide key={index}>
                <SkeletonCard />
              </SwiperSlide>
            ))
          }
          <br />
          <br />
        </Swiper>

        <Box marginTop={3} sx={{ display: { md: 'none' } }} >
          <Button onClick={() => navigate(`/view-noticia/${localStorage.getItem('noticiaId')}`)} variant='outiline' fullWidth style={{ background: '#85287e', color: '#fff', }} >
            Ver mais notícias
          </Button>
        </Box>
      </Container>
    </div>
  )
}


